import {defineStore, storeToRefs} from "pinia";
//@ts-ignore
import {MetaOptions} from "quasar/dist/types/meta";
import {useConfig} from "@/core/store/config";
import cloneDeep from "lodash-es/cloneDeep";
import templater from "@/core/util/templater";
import {useRouterStore} from "@/core/router/store";
import {RouteMetaHtml} from "@/modules/app/types";

export const usePageMeta = defineStore("page-meta", () => {

    const {getConfig} = useConfig()

    const routerStore = useRouterStore()

    const {routeMeta} = storeToRefs(routerStore)

    const fillMeta = (data: MetaOptions) => {

        const routeHtml: RouteMetaHtml = routeMeta.value.html || {}

        if (!routeHtml.title)
            routeHtml.title = routeMeta.value.title

        const metadata: MetaOptions = {
            meta: {},
            ...cloneDeep(data),
        }

        if (!metadata.title) {
            if (routeHtml.title) {
                metadata.title = routeHtml.title
            } else if (getConfig('app', 'APP_META_TITLE')) {
                metadata.title = getConfig('app', 'APP_META_TITLE')
            }
        }

        if (!metadata.titleTemplate && getConfig('app', 'APP_META_TITLE_TEMPLATE')) {
            metadata.titleTemplate = (content: string) => templater(getConfig('app', 'APP_META_TITLE_TEMPLATE'), {
                content
            })
        }

        const metas: (keyof RouteMetaHtml)[] = [
            'description',
            'keywords',
            'equiv',
            'ogTitle'
        ]

        for (const metaName of metas) {
            let metaOptions = metadata.meta![metaName]
            if (!metaOptions || !metaOptions.content) {
                const configContent = routeHtml[metaName] || getConfig('app', 'APP_META_' + metaName.toUpperCase() as any)
                if (configContent) {
                    if (metaOptions) {
                        metaOptions.content = configContent
                    } else {
                        metaOptions = {
                            name: metaName,
                            content: configContent
                        }
                    }
                }
            }
            if (metaOptions) {
                const configTemplate = getConfig('app', 'APP_META_' + metaName.toUpperCase() + '_TEMPLATE' as any)
                if (configTemplate) {
                    metaOptions.template = (content: string) => templater(configTemplate, {
                        content
                    })
                }
                metadata.meta![metaName] = metaOptions
            }
        }

        return metadata
    }

    return {
        fillMeta
    }
})
